<p-toast />

<info-modal
  [modalId]="modalInfoLogoutId"
  [confirmLabel]="'Continuar sesión'"
></info-modal>

<info-modal
  [modalId]="modalLogout"
  iconSrc="clock.svg"
></info-modal>

<router-outlet />